import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TokenServiceService } from './token-service.service';

@Injectable({
  providedIn: 'root',
})
export class BuyerInformationService {
  constructor(
    private http: HttpClient,
    private readonly tokenServiceService: TokenServiceService
  ) {}

  saveBuyer(data) {
    const token = this.tokenServiceService.getToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return this.http.post(
      `${environment.urlglobal_api}/api/v3/checkout/userinfobuyer`,
      data,
      httpOptions
    );
  }
}
